export default {
  fire() {
    $('#campos_ultimo_emprego').click(function () {
        $('#dados_ultimo_emprego').slideToggle('slow', function() {
            if (!$("#campos_ultimo_emprego").hasClass('slideDow')) {
                $(".ultimo").removeAttr('required');
                $(".ultimo").attr('required', true);
                $('#campos_ultimo_emprego').addClass('slideDow');
            } else {
                $(".ultimo").removeAttr('required');
                $(".ultimo").val('');
                $('#campos_ultimo_emprego').removeClass('slideDow');
            }
        });
    });

    $('#campos_penultimo_emprego').click(function () {
        $('#dados_penultimo_emprego').slideToggle('slow', function() {
            if (!$("#campos_penultimo_emprego").hasClass('slideDow')) {
                $(".penultimo").removeAttr('required');
                $(".penultimo").attr('required', true);
                $('#campos_penultimo_emprego').addClass('slideDow');
            } else {
                $(".penultimo").removeAttr('required');
                $(".penultimo").val('');
                $('#campos_penultimo_emprego').removeClass('slideDow');
            }
        });
    });

    $('#campos_antepenultimo_emprego').click(function () {
        $('#dados_antepenultimo_emprego').slideToggle('slow', function() {
            if (!$("#campos_antepenultimo_emprego").hasClass('slideDow')) {
                $(".antepenultimo").removeAttr('required');
                $(".antepenultimo").attr('required', true);
                $('#campos_antepenultimo_emprego').addClass('slideDow');
            } else {
                $(".antepenultimo").removeAttr('required');
                $(".antepenultimo").val('');
                $('#campos_antepenultimo_emprego').removeClass('slideDow');
            }
        });
    });

    function enable(el) {
       el.show();
       el.find('[data-required=1]').each(function () {
         $(this).prop('required', true);
       });
    }

    function disable(el) {
       el.hide();
       el.find('[required]').each(function () {
         $(this).data('required', 1)
           .prop('required', false);
       });
    }

    $('[data-listen]').each(function () {
       var name = $(this).data('listen');
       var $target = $('[name="'+name+'"]');

        $target.on('change keyup', $.proxy(function (event) {
         if (""+$(event.target).val() === ""+this.value || (this.value == '*' && $(event.target).val() !== '')) {
           enable(this.el);
         } else {
           disable(this.el);
         }
       }, { el: $(this), value: $(this).data('if') }))
    });

    $('.custom-checkbox.part-time').hide();
    $('#jovem-aprendiz, #recepcionista-caixa, #embalador-frente-loja').click(function () {
      let checked = $('#jovem-aprendiz').prop("checked") || $('#recepcionista-caixa').prop("checked") || $('#embalador-frente-loja').prop("checked") ? true : false;

      if (checked) {
        $('.custom-checkbox.part-time').show();
      } else {
        $('.custom-checkbox.part-time').hide();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/conditional-component.js